var map = {
	"./en_CA.json": [
		2476,
		"src_assets_i18n_en_CA_json"
	],
	"./en_US.json": [
		7957,
		"src_assets_i18n_en_US_json"
	],
	"./es_MX.json": [
		8273,
		"src_assets_i18n_es_MX_json"
	],
	"./fr_CA.json": [
		4612,
		"src_assets_i18n_fr_CA_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6297;
module.exports = webpackAsyncContext;